import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (

      <div className="container p-6">
        <form>
          <div className="steps mt-6 mb-4 hide-on-tablet">
            <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
              <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                <div className="ant-steps-item-container">
                  <div className="ant-steps-item-tail"></div>
                  <div className="ant-steps-item-icon"><span className="ant-steps-icon">1</span></div>
                  <div className="ant-steps-item-content">
                    <div className="ant-steps-item-title">Verify Token</div>
                    <div className="ant-steps-item-description">Enter the token address and verify </div>
                  </div>
                </div>
              </div>
              <div className="ant-steps-item ant-steps-item-wait">
                <div className="ant-steps-item-container">
                  <div className="ant-steps-item-tail"></div>
                  <div className="ant-steps-item-icon"><span className="ant-steps-icon">2</span></div>
                  <div className="ant-steps-item-content">
                    <div className="ant-steps-item-title">Subscription</div>
                    <div className="ant-steps-item-description">Enter the subscription pool information that you want to raise, that should be enter all details about your presale</div>
                  </div>
                </div>
              </div>
              <div className="ant-steps-item ant-steps-item-wait">
                <div className="ant-steps-item-container">
                  <div className="ant-steps-item-tail"></div>
                  <div className="ant-steps-item-icon"><span className="ant-steps-icon">3</span></div>
                  <div className="ant-steps-item-content">
                    <div className="ant-steps-item-title">Add Additional Info</div>
                    <div className="ant-steps-item-description">Let people know who you are
                    </div>
                  </div>
                </div>
              </div>
              <div className="ant-steps-item ant-steps-item-wait">
                <div className="ant-steps-item-container">
                  <div className="ant-steps-item-tail"></div>
                  <div className="ant-steps-item-icon"><span className="ant-steps-icon">4</span></div>
                  <div className="ant-steps-item-content">
                    <div className="ant-steps-item-title">Finish</div>
                    <div className="ant-steps-item-description">Review your information</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ant-card ant-card-bordered">
            <div className="ant-card-body">
              <div className="field">
                <div className="flex mb-1 items-center"><label className="flex-1 label" for="token">Token Address<sup
                  className="has-text-danger">*</sup></label><button type="button" className="ant-btn ant-btn-default"><span>Create Token</span></button></div>
                <div className="control"><input className="input" type="text" placeholder="Ex: 0x0000..." id="token" name="token" value="" /></div>
                <p className="has-text-info is-size-7">Pool creation fee: 1 BNB</p>
              </div>
              <div className="field">
                <div className="label flex items-center"><label for="currency">Currency</label>
                  <div className="ReloadButton_wrapper__2PKUR">
                    <div className="ReloadButton_root__2iTCz"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z">
                      </path>
                    </svg></div>
                  </div>
                </div>
                <div className="control">
                  <div className="ant-radio-group ant-radio-group-outline" id="currency">
                    <div className="ant-space ant-space-vertical" style={{ gap: "8px" }}>
                      <div className="ant-space-item"><label className="ant-radio-wrapper ant-radio-wrapper-checked"><span
                        className="ant-radio ant-radio-checked"><input
                          name="currency" type="radio" className="ant-radio-input"
                          value="0x0000000000000000000000000000000000000000"
                          checked="" /><span
                            className="ant-radio-inner"></span></span><span>BNB</span></label>
                      </div>
                      <div className="ant-space-item"><label className="ant-radio-wrapper"><span
                        className="ant-radio"><input name="currency" type="radio"
                          className="ant-radio-input"
                          value="0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56" /><span
                            className="ant-radio-inner"></span></span><span>BUSD</span></label>
                      </div>
                      <div className="ant-space-item"><label className="ant-radio-wrapper"><span
                        className="ant-radio"><input name="currency" type="radio"
                          className="ant-radio-input"
                          value="0x55d398326f99059fF775485246999027B3197955" /><span
                            className="ant-radio-inner"></span></span><span>USDT</span></label>
                      </div>
                      <div className="ant-space-item"><label className="ant-radio-wrapper"><span
                        className="ant-radio"><input name="currency" type="radio"
                          className="ant-radio-input"
                          value="0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d" /><span
                            className="ant-radio-inner"></span></span><span>USDC</span></label>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="help is-info">Users will pay with BNB for your token</p>
              </div>
              <div className="field"><label className="label" for="onlyEthFee">Fee Options</label>
                <div className="control">
                  <div className="ant-radio-group ant-radio-group-outline" id="onlyEthFee">
                    <div className="ant-space ant-space-vertical" style={{ gap: "8px" }}>
                      <div className="ant-space-item" ><label className="ant-radio-wrapper ant-radio-wrapper-checked"><span
                        className="ant-radio ant-radio-checked"><input
                          name="onlyEthFee" type="radio"
                          className="ant-radio-input" value="true"
                          checked="" /><span
                            className="ant-radio-inner"></span></span><span>5% BNB
                              raised only <span
                                className="has-text-info">(Recommended)</span></span></label>
                      </div>
                      <div className="ant-space-item"><label className="ant-radio-wrapper"><span
                        className="ant-radio"><input name="onlyEthFee" type="radio"
                          className="ant-radio-input" value="false" /><span
                            className="ant-radio-inner"></span></span><span>2% BNB
                              raised + 2% token sold</span></label></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="has-text-centered">
                <div className="ant-space ant-space-horizontal ant-space-align-center" style={{ gap: "8px" }}>
                  <div className="ant-space-item"><button disabled="" type="button" className="ant-btn ant-btn-primary"><span>Next</span></button></div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
